module.exports = __webpack_public_path__ + "img/rz3.b37b724b.jpeg";